import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { Button, ButtonVariant } from '@/components/form/button';
import { Input } from '@/components/form/input';
import { useAuth } from '@/features/auth';

export type LoginFormFields = {
  email: string;
  password: string;
};

const validationSchema = yup.object({
  email: yup
    .string()
    .email('commonValidation.emailNotValid')
    .required('commonValidation.fieldRequired'),
  password: yup.string().required('commonValidation.fieldRequired'),
});

export const LoginForm = ({ settings }: any) => {
  // global hooks for translation and theme
  const { t } = useTranslation();

  const { signin, isLoading, isError, error } = useAuth();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormFields>({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = handleSubmit((data) => {
    signin({ method: settings.method, ...data });
    reset();
  });

  return (
    <>
      <form onSubmit={onSubmit}>
        <Input<LoginFormFields>
          className={`!bg-white ${settings.inputBorderColor} border-2 w-full md:w-72 z-30 placeholder:text-[#7E7E7E] placeholder:font-bold`}
          name="email"
          type="text"
          placeholder={t('login.email')}
          autoComplete="username"
          register={register}
          errors={errors}
        />
        <Input<LoginFormFields>
          className={`!bg-white ${settings.inputBorderColor} border-2 mt-6 w-full md:w-72 z-30 placeholder:text-[#7E7E7E] placeholder:font-bold`}
          name="password"
          type="password"
          placeholder={t('login.password')}
          autoComplete="current-password"
          register={register}
          errors={errors}
        />
        {isError && (
          <p className="mt-6 text-red-light text-md font-bold">
            {error === 'invalid_webapp_role'
              ? t('login.invalidRole')
              : t('login.invalidCredential')}
          </p>
        )}
        <Button
          classnames={`${settings.loginButtonDropShadowColor} mt-6 ${settings.loginButtonBackgroundColor} z-30`}
          variant={ButtonVariant.Primary}
          type="submit"
          isLoading={isLoading}
        >
          Login
        </Button>
      </form>
    </>
  );
};
